import _ from 'lodash';
import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultStatement = {
  scriptures: [],
  _embedded: {
    image: {},
  },
};

export default {
  actions: {
    async [actions.DO_CREATE_BELIEF_STATEMENT]({ commit }, params) {
      const { data } = await HTTP.post('/belief_statements', params);
      commit(mutations.SET_BELIEF_STATEMENT, data.data.belief_statements[0]);
      return data;
    },
    async [actions.DO_DELETE_BELIEF_STATEMENT]({ commit }, payload) {
      const { id, ignore, ...params } = payload;
      const { data } = await HTTP.delete(`/belief_statements/${id}`, params);
      if (!ignore) commit(mutations.SET_BELIEF_STATEMENT, data.data.belief_statements[0]);
      return data;
    },
    async [actions.DO_GET_BELIEF_STATEMENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/belief_statements/${id}`, { params });
      commit(mutations.SET_BELIEF_STATEMENT, data.data.belief_statements[0]);
      return data;
    },
    async [actions.DO_GET_BELIEF_STATEMENTS]({ commit }, params) {
      const { data } = await HTTP.get('/belief_statements', { params });
      commit(mutations.SET_BELIEF_STATEMENTS, data.data.belief_statements);
      return data;
    },
    async [actions.DO_UPDATE_BELIEF_STATEMENT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/belief_statements/${id}`, params);
      commit(mutations.SET_BELIEF_STATEMENT, data.data.belief_statements[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_BELIEF_STATEMENT]: state => state.statement,
    [getters.GET_BELIEF_STATEMENTS]: state => state.statements,
  },
  mutations: {
    [mutations.INSERT_BELIEF_STATEMENT](state, payload) {
      const index = _.findIndex(state.statements, { id: payload.val.id });
      if (index >= 0) {
        state.statements.splice(index, 1);
      }
      state.statements.splice(payload.index, 0, payload.val);
    },
    [mutations.SET_BELIEF_STATEMENT](state, statement) {
      state.statement = statement;
    },
    [mutations.SET_BELIEF_STATEMENT_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.statement;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_BELIEF_STATEMENTS](state, statements) {
      state.statements = statements;
    },
    [mutations.UNSET_BELIEF_STATEMENT](state) {
      state.statement = _.cloneDeep(defaultStatement);
    },
  },
  state: {
    statement: _.cloneDeep(defaultStatement),
    statements: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/belief_statement.js